import {
  Flex,
  Link,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
  TextLabel,
  Truncate,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { OverAllPolicyType, PolicyItemInTable } from '../utils/types';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { OverAllPolicyTypeContext } from '../OverAllPolicyList/context/OverAllPolicyTypeContext';
import { useNavigateWithHandler } from '@Utils/hooks';

export const PolicyNameCell = ({
  policy,
  disabled: disabledProp,
}: {
  policy: PolicyItemInTable;
  disabled: boolean;
}) => {
  const overAllPolicyType = useContext(OverAllPolicyTypeContext);
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const navigate = useNavigateWithHandler();
  const { t } = useTranslation();
  const path =
    overAllPolicyType === OverAllPolicyType.ATP
      ? 'advanced-threat-protection'
      : 'data-loss-prevention';
  return (
    <Popover arrow={false} trigger="hover" placement="right" enterDelay={500}>
      <PopoverTrigger>
        <Link
          maxWidth="100%"
          onClick={() => {
            navigate(`/policy/${path}/edit-policy/${policy.policyUuid}`);
          }}
          disabled={disabledProp}
        >
          <Truncate>{policy.policyName}</Truncate>
        </Link>
      </PopoverTrigger>
      <PopoverContent
        maxWidth="600px"
        PopperProps={{
          usePortal: true,
        }}
      >
        <Flex direction="column">
          <Flex>
            <TextLabel whiteSpace="nowrap">
              {t('policy.label.policyName')}:&nbsp;
            </TextLabel>
            <Text color={colorStyle.color.primary} wordBreak="break-all">
              {policy.policyName}
            </Text>
          </Flex>
          <Flex>
            <TextLabel>{t('policy.label.policyDescription')}:&nbsp;</TextLabel>
            <Text color={colorStyle.color.primary} wordBreak="break-all">
              {policy.policyDescription}
            </Text>
          </Flex>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
